import { render, staticRenderFns } from "./ReturnRegionalManager.vue?vue&type=template&id=577f344a&scoped=true&"
import script from "./ReturnRegionalManager.vue?vue&type=script&lang=js&"
export * from "./ReturnRegionalManager.vue?vue&type=script&lang=js&"
import style0 from "./ReturnRegionalManager.vue?vue&type=style&index=0&id=577f344a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577f344a",
  null
  
)

export default component.exports